(() => {
  const protectedImageSelector = [
    'img',
    'picture',
    '.product__media img',
    '.card__media img',
    '.banner img',
    '.collection-hero img',
    '.pswp'
  ].join(', ');

  /**
   * Evita aplicar la protección dentro del editor visual de Shopify.
   * Esto ayuda a no interferir con la edición y selección de bloques.
   */
  const isShopifyDesignMode = Boolean(
    window.Shopify && window.Shopify.designMode
  );

  if (isShopifyDesignMode) return;

  document.addEventListener('contextmenu', (event) => {
    const image = event.target.closest(protectedImageSelector);

    if (!image) return;

    event.preventDefault();
  });

  document.addEventListener('dragstart', (event) => {
    const image = event.target.closest(protectedImageSelector);

    if (!image) return;

    
    event.preventDefault();
  });
})();